export default "__VITE_ASSET__DJ_hhq43__"